import React from 'react';
import styled from 'styled-components';


interface BlockWithVisibleProps {
  width: string;
  value: string;
}

const BlockWithVisible: React.FC<BlockWithVisibleProps> = ({ width, value }) => {

  return (
    <>
        <Block $width={width}>
          <Value>
            {value}
          </Value>
        </Block>
    </>
  )
}


const Block = styled.div<{ $width: string; }>`
  flex: ${({ $width }) => $width};

  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 0;
`

const Value = styled.span`
  width: 80%;

  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;

  padding-left: 3px;

  ${({ theme }) => theme.typography.Body_04};
  text-align: center;
`

export default BlockWithVisible;